import React, { Component } from "react";
import "./Lopd.scss";

export default class Lopd extends Component {
  render() {
    return (
      <div className="modalSize">
        <div
          className="modal fade"
          id="myModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myModalLopd"
          aria-hidden="true"
        >
          <div
            style={{ top: this.props.parentPosition }}
            className="modal-dialog modalSize modal-lg"
          >
            <div className="modal-content">
              <div className="modal-header modal-headerLOPD">
                <h2 className="margen-b30 proteccion-datos sizeHeader">
                  Protección datos
                </h2>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="col-12 table table-left ">
                  <div className="row table-row">
                    <div className="sizeInfo col-12 table-cell table-cell--header">
                      Información adicional sobre Protección de datos
                    </div>
                  </div>
                  <div className="row table-row">
                    <div className="col-12 col-md-4 table-cell table-cell--title">
                      <i>Categoría de Datos:</i>
                    </div>
                    <div className="col-12 col-md-8 table-cell">
                      Datos de Contacto.
                    </div>
                  </div>
                  <div className="row table-row">
                    <div className="col-12 col-md-4 table-cell table-cell--title">
                      <i>Responsable</i>
                    </div>
                    <div className="col-12 col-md-8 table-cell">
                      Toyota España, S.L.U (B-80419922), Toyota Motor Europe,
                      S.L.U., Toyota Kreditbank, GMBH, Sucursal en España
                      (W-0043045 –D), Aioi Nissai Dowa Insurance Company of
                      Europe Limited, Sucursal en España (W-0060072-F Toyota
                      Insurance Management, Ltd, Sucursal en España
                      (W-0068886-A) y su{" "}
                      <a
                        href="https://www.toyota.es/forms/forms.json?tab=pane-dealer&amp;showAllResults=true"
                        rel="noopener noreferrer"
                        target="_blank"
                        className="link"
                      >
                        Concesionario habitual
                      </a>{" "}
                      en adelante, todas ellas, denominadas “TOYOTA”, en calidad
                      de cotitulares del fichero de datos de Contacto Clientes
                      TOYOTA.
                      <br />
                      <br />
                      Dirección Postal: Av. de Bruselas, 22, 28108 Alcobendas,
                      Madrid.
                      <br />
                      <br />
                      Teléfono: 910 50 50 00.
                      <br />
                      <br />
                      Correo electrónico:{" "}
                      <a href="mailto:clientes@toyota.es" className="link">
                        clientes@toyota.es
                      </a>
                      <br />
                      <br />
                      Delegado de Protección de Datos (DPO):{" "}
                      <a href="mailto:dpo@toyota.es" className="link">
                        dpo@toyota.es
                      </a>
                      .
                    </div>
                  </div>
                  <div className="row table-row">
                    <div className="col-12 col-md-4 table-cell table-cell--title">
                      <i>Finalidad</i>
                    </div>
                    <div className="col-12 col-md-8 table-cell">
                      <span className="block margen-b15 txt-center">
                        <strong>
                          ¿Con qué finalidad tratamos sus datos personales?
                        </strong>
                      </span>
                      <br />
                      En TOYOTA tratamos los datos que nos facilita con la
                      finalidad de gestionar la relación comercial con el
                      cliente y servicios asociados a la venta del vehículo,
                      como la financiación y el seguro, en el caso de que el
                      cliente tuviera interés en su contratación, así como la
                      gestión de la garantía asociada al vehículo.
                      <br />
                      <br />
                      Asimismo, en caso de que nos dé su consentimiento,
                      trataremos sus datos para realizar las siguientes acciones
                      comerciales:
                      <br />
                      <br />
                      <ul>
                        <li>
                          Enviar recordatorios relacionados con su automóvil y
                          de renovación de servicios TOYOTA que estén a punto de
                          caducar (por ejemplo, el recordatorio ITV).
                          <br />
                        </li>
                        <li>
                          Enviar información sobre ofertas de productos y
                          servicios relacionados con el mundo del Automóvil y la
                          marca TOYOTA, tales como: ofertas de vehículos nuevos
                          y usados, repuestos, accesorios, servicios de
                          asistencia en carretera, garantía extendida,
                          mantenimiento, seguros, leasing, renting,
                          financiación, servicios de conectividad y movilidad.
                          <br />
                          <br />
                        </li>
                        <li>
                          Enviar información sobre eventos relacionados con el
                          mundo TOYOTA.
                          <br />
                          <br />
                        </li>
                        <li>
                          Enviar encuestas TOYOTA.
                          <br />
                          <br />
                        </li>
                      </ul>
                      Las comunicaciones sobre oferta de productos y servicios y
                      experiencia de cliente podrán ser realizadas por cualquier
                      medio, incluidos los medios electrónicos.
                      <br />
                      <br />
                      <span className="block margen-b15 txt-center">
                        <strong>
                          ¿Por cuánto tiempo conservaremos sus datos?
                        </strong>
                      </span>
                      El plazo de conservación de los datos será{" "}
                      <strong>de un año</strong>, mientras no se solicite su
                      supresión por parte del interesado.
                      <br />
                      <br />
                      <span className="block margen-b15 txt-center">
                        <strong>¿Qué tipo de perfilado realizamos?</strong>
                      </span>
                      Con el fin de poder ofrecerle productos y servicios de
                      acuerdo con sus intereses y mejorar su experiencia de
                      cliente, elaboraremos un perfil comercial en base a la
                      información facilitada. No se tomarán decisiones
                      automatizadas en base a dicho perfil.
                    </div>
                  </div>
                  <div className="row table-row">
                    <div className="col-12 col-md-4 table-cell table-cell--title">
                      <i>Legitimación</i>
                    </div>
                    <div className="col-12 col-md-8 table-cell">
                      La base legal para gestionar la relación comercial con el
                      cliente es el consentimiento del cliente.
                      <br />
                      <br />
                      Los datos solicitados señalados con asterisco son de
                      cumplimentación obligatoria, la no cumplimentación de los
                      mismos impedirá la prestación de un servicio de calidad.
                    </div>
                  </div>
                  <div className="row table-row">
                    <div className="col-12 col-md-4 table-cell table-cell--title">
                      <i>Destinatarios</i>
                    </div>
                    <div className="col-12 col-md-8 table-cell">
                      No se cederán datos a terceros, salvo obligación legal o
                      que sea necesario para prestar un servicio solicitado por
                      el cliente.
                    </div>
                  </div>
                  <div className="row table-row">
                    <div className="col-12 col-md-4 table-cell table-cell--title">
                      <i>Destinatarios fuera de la UE</i>
                    </div>
                    <div className="col-12 col-md-8 table-cell">
                      Sus datos serán transferidos a Salesforce.com, The
                      Landmark @ One Market Street, San Francisco, CA 94105,
                      USA, en calidad de encargado de tratamiento para el
                      procesamiento técnico de los mismos y al amparo del
                      acuerdo EU-US Privacy Shield. - Información disponible en:{" "}
                      <a href="https://www.privacyshield.gov/participant?id=a2zt0000000TOWQAA4">
                        https://www.privacyshield.gov/participant?id=a2zt0000000TOWQAA4
                      </a>
                      .
                    </div>
                  </div>
                  <div className="row table-row">
                    <div className="col-12 col-md-4 table-cell table-cell--title">
                      <i>Derechos</i>
                    </div>
                    <div className="col-12 col-md-8 table-cell">
                      Cualquier persona tiene derecho a obtener confirmación
                      sobre si en TOYOTA estamos tratando datos personales que
                      le conciernan o no.
                      <br />
                      <br />
                      Las personas interesadas tienen derecho a acceder a sus
                      datos personales, así como a solicitar la rectificación de
                      datos inexactos o, en su caso, solicitar su supresión
                      cuando, entre otros motivos, los datos ya no sean
                      necesarios para los fines que fueron recogidos.
                      <br />
                      <br />
                      En determinadas circunstancias y por motivos relacionados
                      con su situación particular, los interesados podrán
                      oponerse al tratamiento de sus datos. TOYOTA dejará de
                      tratar los datos salvo por motivos legítimos imperiosos, o
                      el ejercicio o la defensa de posibles reclamaciones.
                      <br />
                      <br />
                      En determinadas circunstancias, los interesados podrán
                      solicitar la limitación del tratamiento, de modo que
                      TOYOTA sólo los reservará y utilizará en los casos
                      autorizados por la Ley.
                      <br />
                      <br />
                      Cuando los datos se recogen en un formato estructurado,
                      los interesados podrán pedir a TOYOTA la transmisión
                      directa de sus datos a otros responsables o recibir sus
                      datos en formato electrónico, para almacenarlos en sus
                      dispositivos propios, sin necesidad de transmitirlos a
                      otros responsables.
                      <br />
                      <br />
                      Los interesados podrán retirar su consentimiento, sin que
                      ello afecte a la legitimidad de los tratamientos
                      realizados con carácter previo.
                      <br />
                      <br />
                      Si los interesados entienden que los tratamientos
                      realizados por TOYOTA no se ajustan a la legalidad, puede
                      presentar reclamación ante la Autoridad de Control
                      (www.aepd.es)
                      <br />
                      <br />
                      Todo lo anterior se podrá realizar, mediante:
                      <br />
                      <br />
                      <ul>
                        <li>
                          los formularios que se encuentran a su disposición en
                          la dirección indicada.
                          <br />
                          <br />
                        </li>
                        <li>
                          el envío de una solicitud a la dirección indicada.
                          <br />
                          <br />
                        </li>
                        <li>
                          el envío de un correo electrónico a la dirección:{" "}
                          <a href="mailto:dpo@toyota.es" className="link">
                            dpo@toyota.es
                          </a>
                          <br />
                          <br />
                        </li>
                      </ul>
                      Independientemente del modo utilizado, deberá adjuntar
                      fotocopia del DNI o documento identificativo sustitutorio.
                    </div>
                  </div>
                  <div className="row table-row">
                    <div className="col-12 col-md-4 table-cell table-cell--title">
                      <i>Más información</i>
                    </div>
                    <div className="col-12 col-md-8 table-cell">
                      <a
                        href="https://www.toyota.es/politica-privacidad.json"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="link"
                      >
                        Política de Protección de Datos
                      </a>
                      .
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
